// @ts-nocheck
import {Column} from 'react-table'
import {LastPaymentsCustomHeader} from './LastPaymentsCustomHeader'
import {Properties} from '../../core/_models'
import {LastPaymentsOwnersCell} from './LastPaymentsOwnersCell'
//import {LastPaymentsNumberCell} from './LastPaymentsNumberCell'
import {LastPaymentsValueCell} from './LastPaymentsValueCell'
//import {LastPaymentsDateCell} from './LastPaymentsDateCell'

const propertiesColumns: ReadonlyArray<Column<Properties>> = [
  {
    Header: (props) => (
      <LastPaymentsCustomHeader
        tableProps={props}
        title='PROPERTIES.NAME'
        className='fs-8 text-center flex-row-fluid flex-center'
      />
    ),
    id: 'property',
    Cell: ({...props}) => <LastPaymentsValueCell property={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <LastPaymentsCustomHeader
        tableProps={props}
        title='PROJECT.PROJECT_TITLE'
        className='fs-8  text-center flex-row-fluid flex-center'
      />
    ),
    id: 'owner',
    Cell: ({...props}) => <LastPaymentsOwnersCell property={props.data[props.row.index]} />,
  },

  {
    Header: (props) => (
      <LastPaymentsCustomHeader
        tableProps={props}
        title='COMMON.VALUE'
        className='fs-8  text-center flex-row-fluid flex-center'
      />
    ),
    id: 'city',
    Cell: ({...props}) => <LastPaymentsValueCell property={props.data[props.row.index]} />,
  },
  {
    Header: (props) => (
      <LastPaymentsCustomHeader
        tableProps={props}
        title='CONTRACTS.PAYMENT_DATE'
        className='fs-8  text-center flex-row-fluid flex-center'
      />
    ),
    id: 'date',
    Cell: ({...props}) => <LastPaymentsValueCell property={props.data[props.row.index]} />,
  },
]

export {propertiesColumns}
